<template>
    <div class="p-2">
        <div class="form-group">
            <label for="mode" class="form-control-label mb-0">{{ trans('Mode') }}:</label>
            <v-select
                :placeholder="trans('Select...')"
                id="mode_id"
                label="text"
                :options="modeOptions"
                :modelValue="settings.zoom"
                @update:modelValue="settings.zoom = $event"
                :reduce="(mode) => mode.id"
            >
            </v-select>
        </div>
        <div class="form-group">
            <label for="amount_id" class="form-control-label mb-0">{{ trans('Amount') }}:</label>
            <v-select
                :placeholder="trans('Select...')"
                id="amount_id"
                label="text"
                :options="amountOptions"
                :modelValue="settings.amount"
                @update:modelValue="settings.amount = $event"
            >
            </v-select>
        </div>
        <div class="form-group">
            <label for="from_date" class="form-control-label mb-0">{{ trans('From') }}:</label>
            <vue-flatpickr
                :modelValue="settings.from"
                @update:modelValue="settings.from = $event"
                :config="config"
                :placeholder="trans('Select date')"
                name="from_date"
                autocomplete="off"
                class="form-control"
            >
            </vue-flatpickr>
        </div>
        <button class="btn btn-secondary" type="button" @click.stop="reset()">
            {{ trans('reset') }}
        </button>
        <a class="btn btn-primary text-white ml-1" target="_blank" :href="pdfCalendarUrl">
            {{ trans('Generate pdf') }}
        </a>
    </div>
</template>

<script>
import VueFlatpickr from 'vue-flatpickr-component';
import { mapState } from 'vuex';

export default {
    components: {
        VueFlatpickr,
    },
    props: {},
    data() {
        return {
            settings: {
                zoom: null,
                amount: 1,
                from: new Date(),
            },
            momentDateFormat: 'DD-MM-YYYY',
            config: {
                allowInput: true,
                dateFormat: 'd-m-Y',
            },
            modeOptions: [
                {
                    id: 0,
                    text: trans('Day'),
                },
                {
                    id: 1,
                    text: trans('Week'),
                },
                {
                    id: 2,
                    text: trans('Month'),
                },
            ],
        };
    },
    watch: {},
    mounted() {
        this.settings.zoom = this.currentZoom;
    },
    methods: {
        reset() {
            this.settings.zoom = this.currentZoom;
            this.settings.amount = 2;
            this.settings.from = new Date();
        },
        getQuarter(d) {
            var q = [4, 1, 2, 3];
            return q[Math.floor((d.getMonth() + 1) / 3)];
        },
        getSortByType() {
            var sortOrder = this.sortOrder == 'ASC' ? 'ASC' : 'DESC';
            switch (this.sort) {
                case 'order':
                    if (this.mode == 'team') {
                        return 'SORT_TEAM_MANUAL';
                    }
                    if (this.mode == 'person') {
                        return 'SORT_PEOPLE_MANUAL';
                    }
                    break;
                case 'title':
                    return 'SORT_TEAM_' + sortOrder;
                    break;
                //Person sorting
                case 'team-order':
                    return 'SORT_PERSON_TEAM_MANUAL';
                    break;
                case 'team-title':
                    return 'SORT_PERSON_TEAM_' + sortOrder;
                    break;
                case 'department-title':
                    return 'SORT_PERSON_DEPARTMENT_' + sortOrder;
                    break;
                case 'last_name':
                    return 'SORT_PERSON_LAST_NAME_' + sortOrder;
                    break;
                //project sorting
                case 'project-title':
                    return 'SORT_PROJECT_' + sortOrder;
                    break;
                case 'project-deadline_at':
                    return 'SORT_PROJECT_DEADLINE_' + sortOrder;
                    break;
            }
        },
        getMode() {
            switch (this.mode) {
                case 'projectPersons':
                    return 5;
                case 'dailyPlanned':
                    return 4;
                case 'person':
                    return 3;
                case 'team':
                    return 2;
                case 'project':
                    return 1;
            }
        },
    },
    computed: {
        ...mapState('planning', ['mode', 'currentZoom', 'sort', 'sortOrder', 'search']),
        ...mapState('planningFilter', ['filter']),
        amountOptions() {
            let items = [];

            switch (this.settings.zoom) {
                case 0:
                    items = [1, 2, 3, 4, 5, 6, 7];
                    break;
                case 1:
                    items = [1, 2, 3, 4, 5];
                    break;
                case 2:
                    items = [1, 2, 3];
                    break;
            }

            return items;
        },
        pdfCalendarUrl() {
            var mydate = moment(this.settings.from, this.momentDateFormat);
            let params = {
                amount: this.settings.amount,
                calendar_type: this.getMode(),
                day: mydate.date(),
                week: mydate.week(),
                month: mydate.month() + 1,
                quarter: mydate.quarter(),
                year: mydate.year(),
                calendar_view: this.settings.zoom,
                planning: 1,
                search: this.search,
                planned: 0,
                sortBy: this.getSortByType(),
            };

            // Add filter data for dailyPlanned mode
            if ((this.mode === 'dailyPlanned' || this.mode === 'projectPersons') && this.filter) {
                const allowedFilters = ['department_ids', 'team_ids'];
                const filter = Object.fromEntries(
                    Object.entries(this.filter)
                        .filter(([key]) => allowedFilters.includes(key))
                        .filter(([key, value]) => value && value.length > 0)
                );
                
                Object.entries(filter).forEach(([key, value]) => {
                    params[`filter[${key}]`] = value;
                });
            }
            
            return route('schedule.pdf-planning') + '?' + jQuery.param(params);
        },
    },
};
</script>

<style scoped></style>
